import { z } from "zod";
/**
 * @deprecated It's recommended to use new, more granular notification settings. We keep this for backward compatibility.
 */
export const LiveblocksNotificationSettings = z.object({
    sendCommentNotificationEmails: z.boolean(),
});
export const NotificationType = z.enum([
    "DesignDocumentComment",
    "ChatMention",
    "ProjectDocumentComment",
    "ProjectInvitation",
]);
export const NotificationChannel = z.enum(["Email", "InApp"]);
export const NotificationSettingOptions = z.object({
    enabled: z.boolean(),
    email: z.boolean(),
});
export const NotificationSettings = z.object({
    [NotificationType.enum.ChatMention]: NotificationSettingOptions,
    [NotificationType.enum.ProjectDocumentComment]: NotificationSettingOptions,
    [NotificationType.enum.ProjectInvitation]: NotificationSettingOptions,
    [NotificationType.enum.DesignDocumentComment]: NotificationSettingOptions.omit({
        enabled: true,
    }),
});
export const UserNotificationSettings = NotificationSettings.merge(z.object({
    /**
     * @deprecated Use granular notification settings instead.
     */
    liveblocksNotificationSettings: LiveblocksNotificationSettings,
}));
export const defaultNotificationSettings = {
    liveblocksNotificationSettings: {
        sendCommentNotificationEmails: true,
    },
    DesignDocumentComment: { email: true },
    ChatMention: { enabled: true, email: true },
    ProjectInvitation: { enabled: true, email: true },
    ProjectDocumentComment: { enabled: true, email: true },
};
